import { Account } from './account';

export interface RegisteredAccount extends Account {
  registrationToken: string;
}
